import { FC, Fragment, useEffect } from 'react';
// Redux
import { useAppDispatch } from 'app/hooks/useStore';
// Async
import { getUsers } from 'app/store/Users/Users.async';
// Actions
import { UsersActions } from 'app/store/Users/Users.slice';
// Mui
import { Box, Container, Toolbar, Typography } from '@mui/material';
// 
import UsersFilter from './UsersFilter';
import UsersList from './UsersList';
import UsersFab from './UsersFab';
// i18next
import { useTranslation } from 'react-i18next';

const UsersPage:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getUsers({}));
    return () => {
      dispatch(UsersActions.setInitialField('filter'));
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Toolbar variant="dense">
        <Typography variant="h6">{t('pages.users.title')}</Typography>
      </Toolbar>
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }} react-action="scroll">
        <Container sx={{ pt: 4, pb: 20 }} maxWidth="sm">
          <UsersFilter />
          <UsersList />
        </Container>
      </Box>
      <UsersFab />
    </Fragment>
  )
}

export default UsersPage;
